import { collection, getDocs, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { LanguageAssistant } from "../type";

export const getLanguageAssistants = async (): Promise<LanguageAssistant[]> => {
  const collectionRef = collection(db, "languagesAssistants");
  const q = query(collectionRef);

  const snapshot = await getDocs(q);

  if (snapshot.empty) return [];

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  })) as LanguageAssistant[];
};
